export default __webpack_public_path__ + "static/media/Model.09a4431c.svg";